import { Component, Injector, Input, Optional } from '@angular/core';

import { ArtikelVerkoopPrijzenService } from 'src/app/core/service/artikel-verkoop-prijzen.service';
import { ArtikelVerkoopPrijzen } from 'src/app/core/dto/artikel-verkoop-prijzen';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Artikel } from 'src/app/core/dto/artikel';

@Component({
    selector: 'c-i-j-borculo-artikel-verkoop-prijzen-collection',
    templateUrl: './artikel-verkoop-prijzen-collection.component.html'/*,
    styleUrls: ['./artikel-verkoop-prijzen-collection.component.css'] */
})
export class ArtikelVerkoopPrijzenCollectionComponent extends PagedCollectionComponent<ArtikelVerkoopPrijzen> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<ArtikelVerkoopPrijzen>([
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ArtikelVerkoopPrijzenService, @Optional() protected filter: Filter<ArtikelVerkoopPrijzen>, injector: Injector) {
        super('/artikelVerkoopPrijzen/artikelVerkoopPrijzen', injector, ArtikelVerkoopPrijzen);
        
        this.initInput('artikel', this.filterBuilder.equal(x => x.artikel.id));            
        this.orderBy = [-2];

		this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		this.filter.onGetChipLabel(x => x.datum, () => 'Datum');
    }

    @Input() set artikel(val: Artikel) { this.handleInput('artikel', val.id); }

    canDelete() {
        return false;
    }
}